import { connect } from 'react-redux'

import * as api from '../../../actions/api'
import * as actions from '../../../actions'
import {
  Comment,
} from '../../../components'

const mapStateToProps = (state, ownProps) => {
  const { settings } = state.settings
  const { records } = state.comment
  const { language } = state.user
  var record
  record = records.find(rc => rc.id === ownProps.id)
  return ({
    settings,
    record,
    language
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
    init: () => {
      dispatch(actions.comment.requestSelect())
      dispatch(api.comment.select(ownProps.id, (response) => {
        dispatch(actions.comment.responseSelect(response))
      }))
    },
    handleClickComment: (comment) => {
      dispatch(api.comment.add(ownProps.id, comment, (response) => {
        if (response.result === false) {
          return
        }
        dispatch(api.comment.select(ownProps.id, (response) => {
          dispatch(actions.comment.responseSelect(response))
        }))
      }))
    },
    handleClickDelete: (index) => () => {
      dispatch(api.comment.delete(ownProps.id, index, (response) => {
        if (response.result === false) {
          return
        }
        dispatch(api.comment.select(ownProps.id, (response) => {
          dispatch(actions.comment.responseSelect(response))
        }))
      }))
    },
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Comment)


// WEBPACK FOOTER //
// ./src/containers/Common/Comment/Comment.js